export default class BApp {
  static isProduct () {
    let _isProduct = false;

    let reg = /^(192.168.3.)/;
    if (window.location.hostname !== 'localhost' && !reg.test(window.location.hostname)) {
      _isProduct = true;
    }

    return _isProduct;
  }

}